import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ICheckboxTableProps } from './CheckboxTable';
import Pagination from './Pagination';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const defaultProps: Pick<ICheckboxTableProps, 'ThComponent' | 'PaginationComponent' | 'minRows'> = {
  // eslint-disable-next-line react/display-name
  ThComponent: ({ toggleSort, className, children, ...rest }) => (
    <button className={`rt-th ${className}`} onClick={e => toggleSort && toggleSort(e)} role="columnheader" {...rest}>
      {children}
      <FontAwesomeIcon icon={faAngleDown as IconDefinition} />
    </button>
  ),
  PaginationComponent: Pagination,
  minRows: 0,
};

export default defaultProps;
